import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { CLI_CINEMA_CLIENT_ID, PROGRAM_CINEMAS, WEISCHERAD_DEFAULT } from '../../../constants/state'
import getData from '../../../functions/getData'
import { weischerAdAddItem } from '../../../actions'
import EditWeischerAd from '../../PageEditItem/present/EditWeischerAd'
import { push } from 'connected-react-router'

const mapStateToProps = state => ({
    itemData: WEISCHERAD_DEFAULT,
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: itemData => {
        dispatch(weischerAdAddItem(itemData))
        dispatch(push(ownProps.closePagePath))
    }
})

const AddWeischerAdContainer = ({itemData, onUpdateItem, cliCinemas, closePagePath, weischerType='main', clientCinemaId}) => <EditWeischerAd
    itemData={itemData}
    onUpdateItem={onUpdateItem}
    cliCinemas={cliCinemas}
    weischerType={weischerType}
    closePagePath={closePagePath}
    clientCinemaId={clientCinemaId}
/>

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(AddWeischerAdContainer)